import { FC, Fragment } from 'react';
import {
    PerformDateRangeFilterSelector,
    PerformGreaterLessInput,
    PerformMultiSelect,
    PerformRefdtoMultiSelect,
} from '../perform-indicator/perform-indicator';
import { InvoiceFilterDto } from '@servicetitan/application-data/marketing';
import * as Styles from './segment-parts.module.less';

interface InvoiceProps {
    invoice: InvoiceFilterDto;
}

export const Invoice: FC<InvoiceProps> = ({ invoice }) => (
    <Fragment>
        <div className={Styles.segmentCardKpiName}>Invoice</div>
        <div>
            <PerformDateRangeFilterSelector
                name="Invoice Date"
                valueStatic={invoice.date}
                valueDynamic={invoice.dateRelative}
            />
            <PerformDateRangeFilterSelector
                name="Invoice Due Date"
                valueStatic={invoice.paymentDueDate}
                valueDynamic={invoice.paymentDueDateRelative}
            />
            <PerformGreaterLessInput name="Total" value={invoice.total} />
            <PerformGreaterLessInput name="Subtotal" value={invoice.subtotal} />
            <PerformRefdtoMultiSelect name="Technician" value={invoice.technicians} />
            <PerformMultiSelect name="Tasks" value={invoice.services} />
            <PerformMultiSelect name="Materials" value={invoice.materials} />
            <PerformMultiSelect name="Equipment" value={invoice.equipments} />
            <PerformRefdtoMultiSelect name="Business Unit" value={invoice.businessUnits} />
            <PerformRefdtoMultiSelect name="Job Type" value={invoice.jobTypes} />
            <PerformDateRangeFilterSelector
                name="Scheduled Job Date"
                valueStatic={invoice.jobScheduled}
                valueDynamic={invoice.jobScheduledRelative}
            />
            <PerformDateRangeFilterSelector
                name="Job Completed Date"
                valueStatic={invoice.jobCompleted}
                valueDynamic={invoice.jobCompletedRelative}
            />
            <PerformMultiSelect name="Job Tag" value={invoice.jobTags} />
            <PerformMultiSelect name="Location Zip Code" value={invoice.zipCodes} />
            <PerformGreaterLessInput name="Balance" value={invoice.balance} />
        </div>
    </Fragment>
);
